import { load } from "../events/load";
import { clickOn } from "../events/click";
import { onResize } from "../events/resize";
import { initTimer } from "../events/timer";
import { getPage } from "../page";

onResize(() => {
  if (getPage() !== "home") return;
  initTimer("setIndexesGallery", gallery.setIndexes.bind(gallery), 100);
}, 992);

const gallery = {
  list: null,
  items: null,
  active: 0,
  counter: null,
  buttons: null,
  canChange: true,
  prevClick: function () {
    if (this.active === 0 || !this.canChange) return;

    this.items[this.active].classList.add("fade-out");
    this.canChange = false;

    setTimeout(() => {
      this.items[this.active].classList.remove("fade-out");
      this.items[this.active - 1].classList.remove("hidden");
      this.active--;
      this.active === 0
        ? this.buttons[0].classList.remove("canPrev")
        : this.buttons[0].classList.add("canPrev");
      this.buttons[1].classList.add("canNext");
      this.items.forEach((item) => item.classList.remove("active", "next"));
      this.items[this.active].classList.add("active");
      this.items[this.active + 1].classList.add("next");
      this.updateCounter();
    }, getComputedStyle(this.items[this.active]).getPropertyValue("--_anim-speed").replace("s", "") * 500);
    setTimeout(() => {
      this.canChange = true;
    }, getComputedStyle(this.items[this.active]).getPropertyValue("--_anim-speed").replace("s", "") * 1500);
  },
  nextClick: function () {
    if (this.active === this.items.length - 1 || !this.canChange) return;
    this.items[this.active].classList.add("fade-out", "hidden");
    this.canChange = false;

    setTimeout(() => {
      this.items[this.active].classList.remove("fade-out");
      this.active++;
      this.active === this.items.length - 1
        ? this.buttons[1].classList.remove("canNext")
        : this.buttons[1].classList.add("canNext");
      this.buttons[0].classList.add("canPrev");
      this.items.forEach((item) => item.classList.remove("active", "next"));
      this.items[this.active + 1]?.classList.add("next");
      this.items[this.active].classList.add("active");
      this.updateCounter();
    }, getComputedStyle(this.items[this.active]).getPropertyValue("--_anim-speed").replace("s", "") * 500);

    setTimeout(() => {
      this.canChange = true;
    }, getComputedStyle(this.items[this.active]).getPropertyValue("--_anim-speed").replace("s", "") * 1500);
  },
  updateCounter() {
    if (!this.counter) return;
    this.setIndexes();
    this.counter.innerHTML = `${this.active + 1}/${this.items.length}`;
  },
  setIndexes() {
    if (window.innerWidth >= 992) return;
    [...this.items]?.forEach((item) => item.removeAttribute("data-index"));
    [...this.items]?.slice(this.active + 1).forEach((item, index) => {
      item.style.left = "";
      item.style.opacity = 1;
      item.style.visibility = "visible";
      item.setAttribute("data-index", index + 1);
      if (index > 3) {
        item.style.left = `140vw`;
        item.style.opacity = 0;
        item.style.visibility = "hidden";
      }
      item.style.zIndex = index + 1;
    });
  },
  slideTo(index = this.active) {
    if (index < 0 || index >= this.items.length) return;
    this.items[this.active].classList.add("fade-out", "hidden");
    this.canChange = false;

    setTimeout(() => {
      console.log(this.active, index);
      for (let i = 0; i < index; i++) {
        if (this.active === this.items.length - 1) break;
        this.items[this.active].classList.remove("fade-out");
        this.items[this.active].classList.add("hidden");
        this.active++;
        this.active === this.items.length - 1
          ? this.buttons[1].classList.remove("canNext")
          : this.buttons[1].classList.add("canNext");
        this.buttons[0].classList.add("canPrev");
        this.items.forEach((item) => item.classList.remove("active", "next"));
        this.updateCounter();
      }
      this.items[this.active + 1]?.classList.add("next");
      this.items[this.active].classList.add("active");
    }, getComputedStyle(this.items[this.active]).getPropertyValue("--_anim-speed").replace("s", "") * 500);

    setTimeout(() => {
      this.canChange = true;
    }, getComputedStyle(this.items[this.active]).getPropertyValue("--_anim-speed").replace("s", "") * 1500);
  },
};

load(() => {
  gallery.list = document.querySelector("#gallery .container");
  if (!gallery.list) return;
  gallery.items = gallery.list.querySelectorAll(".gallery-image");
  gallery.items[0].classList.add("active");
  gallery.items[1]?.classList.add("next");
  gallery.counter = document.querySelector("#gallery .counter");
  gallery.buttons = [
    document.querySelector("#gallery .prev"),
    document.querySelector("#gallery .next"),
  ];
  gallery.buttons[1].classList.add("canNext");

  gallery.counter.innerHTML = `1/${gallery.items.length}`;
  gallery.setIndexes.bind(gallery)();

  clickOn("#gallery .prev", gallery.prevClick.bind(gallery));
  clickOn("#gallery .next", gallery.nextClick.bind(gallery));
  clickOn(
    "#gallery .gallery-image:not(.active), #gallery .gallery-image:not(.active) *",
    (e) => {
      if (window.innerWidth < 992) {
        gallery.slideTo(
          parseInt(
            e.target.closest(".gallery-image").getAttribute("data-index")
          )
        );
      } else {
        gallery.nextClick();
      }
    }
  );
  clickOn(
    "#gallery .gallery-image.active, #gallery .gallery-image.active *",
    (e) => {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
      if (e.target.classList?.contains("gallery-image")) {
        e.target.requestFullscreen();
      } else {
        e.target.closest(".gallery-image").requestFullscreen();
      }
    }
  );
});
